import LogRocket from 'logrocket';
import screenfull from 'screenfull';

import { iPhone } from 'Utils/agent';
import template from './cameraControls.html';

/* @ngInject */
function CameraControlsController($uibModal, $log, growl, CameraService) {
  const vm = this;

  let cameras = null;
  let dontReset = false;
  let growlMessage;

  /* * public variables * */
  vm.canFs = screenfull.isEnabled && !iPhone(); // TODO: only <video> elements can fs on ios
  vm.disableRecordings = false;

  /* * public functions * */
  vm.$onInit = init;
  vm.getCameras = getCameras;
  vm.resetIR = resetIR;
  vm.takeSnapshot = takeSnapshot;
  vm.openRecordings = openRecordings;

  Object.defineProperty(vm, 'currentCamera', {
    get() {
      return CameraService.getCamera(vm.panel?.id, vm.cameraId);
    }
  });

  function init() {
    cameras = CameraService.getCamerasForPanel(vm.panel?.id);
  }


  function getCameras() {
    return cameras;
  }

  function resetIR() {
    if (!dontReset) {
      dontReset = true;
      growlMessage = growl.info('Resetting IR');
      CameraService.resetIRCutFilter(vm.cameraId)
        .then(() => {
          growlMessage.destroy();
          growl.success('IR Reset Successful');
        })
        .catch((err) => {
          growlMessage.destroy();
          const error = 'IR could not be reset';
          growl.error(err, { title: error });
          LogRocket.track(error);
          $log.error(err);
        })
        .finally(() => {
          dontReset = false;
        });
    }
  }

  function takeSnapshot() {
    vm.savingZoom = true;
    growlMessage = growl.info('Taking snapshot...', {
      disableCloseButton: true
    });
    const sendSelectedStream = CameraService.hasMultiViews(vm.panel?.id, vm.cameraId) ?
      vm.selectedStream :
      undefined;
    CameraService.getSnapshot(vm.cameraId, sendSelectedStream)
      .then(() => {
        if (growlMessage) {
          growlMessage.destroy();
        }
        growlMessage = growl.success('Snapshot successful!');
      })
      .catch((res) => {
        if (growlMessage) {
          growlMessage.destroy();
        }
        growlMessage = growl.error(res.error, {
          title: 'Error taking snapshot:'
        });
      });
  }

  function openRecordings() {
    screenfull.exit(); // Modal is hidden if any element is full-screen

    if (vm.disableRecordings) {
      growlMessage = growl.warning('You are not permitted to view recordings');
    } else {
      $uibModal.open({
        component: 'recordings',
        size: 'lg',
        resolve: {
          cameraId() {
            return vm.cameraId;
          },
          panel() {
            return vm.panel;
          },
          cameras() {
            return vm.camsAndViews?.cameras;
          },
          selectedStream() {
            return vm.selectedStream;
          }
        }
      });
      if (vm.playingVideo) {
        vm.toggleVideo({ stop: true });
      }
    }
  }
}

export default {
  name: 'cameraControls',
  template,
  controllerAs: 'CameraControlsCtrl',
  controller: CameraControlsController,
  bindings: {
    playingVideo: '<',
    cameraId: '<',
    selectedStream: '<',
    panel: '<',
    toggleVideo: '&',
    toggleFullscreen: '&',
    toggleOverlay: '&?',
    camsAndViews: '<?'
  }
};
